// Если пользователь открыл страницу до деплоя, ленивые чанки/картинки старой сборки
// после деплоя отдают 404 — страница «ломается» (пустые изображения) до F5.
// Ловим такие ошибки и автоматически перезагружаем страницу, чтобы подхватилась
// актуальная сборка.
//
// Раньше флаг «уже перезагружались» ставился в sessionStorage и НИКОГДА не снимался:
// вкладка, пережившая несколько деплоев, больше не перезагружалась и оставалась
// со сломанными картинками. Теперь:
//   * считаем попытки и держим паузу между перезагрузками;
//   * после успешного старта приложения «карантин» снимается — следующий деплой
//     снова сможет инициировать перезагрузку;
//   * не больше MAX_RELOADS за сессию, чтобы не попасть в цикл.
const RELOAD_KEY = 'chunk-reload-done';
const COUNT_KEY = 'chunk-reload-count';
const MAX_RELOADS = 2;
const MIN_INTERVAL = 30000;

const readCount = () => {
  try {
    return Number(sessionStorage.getItem(COUNT_KEY) || 0);
  } catch (e) {
    return 0;
  }
};

const canReload = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (readCount() >= MAX_RELOADS) {
      return false;
    }

    return !last || (Date.now() - last > MIN_INTERVAL);
  } catch (e) {
    return false;
  }
};

const isChunkError = (message) => {
  const text = String(message || '');

  return (
    /Loading chunk [\w-]+ failed/i.test(text) ||
    /Loading CSS chunk [\w-]+ failed/i.test(text) ||
    /ChunkLoadError/i.test(text) ||
    /error loading dynamically imported module/i.test(text)
  );
};

const tryReload = () => {
  if (!canReload()) {
    return;
  }

  try {
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    sessionStorage.setItem(COUNT_KEY, String(readCount() + 1));
  } catch (e) {
    return;
  }

  // Перезагружаемся с обходом кэша: обычный reload() отдаёт тот же HTML
  // со старыми именами чанков (304), и цикл повторяется. location.reload(true)
  // в современных Chrome игнорируется, поэтому подставляем одноразовый параметр.
  setTimeout(() => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('_cr', String(Date.now()));
      window.location.replace(url.toString());
    } catch (e) {
      window.location.reload();
    }
  }, 100);
};

// Приложение успешно поднялось — снимаем «карантин», чтобы следующий деплой
// (когда у пользователя снова окажется старая сборка) мог перезагрузить страницу.
const clearGuardAfterBoot = () => {
  const reset = () => {
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch (e) {
      /* ignore */
    }
  };

  if (document.readyState === 'complete') {
    setTimeout(reset, 4000);

    return;
  }

  window.addEventListener('load', () => setTimeout(reset, 4000));
};

export default function () {
  if (process.server || typeof window === 'undefined') {
    return;
  }

  // 404 на чанк или на статический ассет сборки: <script>/<link> стилей
  window.addEventListener('error', (event) => {
    const target = event && event.target;
    if (target && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
      const url = target.src || target.href || '';
      if (/_nuxt\//.test(url)) {
        tryReload();

        return;
      }
    }

    const message = event && (event.message || (event.error && event.error.message));
    if (isChunkError(message)) {
      tryReload();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event && event.reason;
    const message = reason && (reason.message || reason);
    if (isChunkError(message)) {
      tryReload();
    }
  });

  clearGuardAfterBoot();
}
